import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { visaApi } from "@/lib/visa";
import { fmtDate, countryFlag } from "@/lib/format";
import { Plane, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const roleBase = (role) => ({ admin: "/admin", coordinator: "/coordinator", partner: "/partner", patient: "/portal" }[role] || "/admin");

export default function VisaTravel() {
  const { user } = useAuth();
  const base = roleBase(user?.role);
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    visaApi.travel().then((r) => { setItems(r); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="visa-travel-page">
      <PageHeader eyebrow="International Services" title="Travel Coordination"
        subtitle="Arrival, departure and airport logistics for confirmed patients." />
      {loading ? <div className="text-sm text-[#5C6660]">Loading…</div> : items.length === 0 ? (
        <div className="bg-white border border-[#E8E6E1] rounded-2xl p-10 text-center text-sm text-[#8E9992]">
          <Plane className="mx-auto mb-2 text-[#8E9992]" size={28} />
          No travel plans logged yet.
        </div>
      ) : (
        <div className="bg-white border border-[#E8E6E1] rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#FAFAF7] border-b border-[#E8E6E1]">
              <tr>
                {["Patient", "Nationality", "Arrival", "Departure", "Airport", "Pickup", ""].map((h) => (
                  <th key={h} className="text-left px-4 py-3 text-[11px] uppercase tracking-wider text-[#8E9992] font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map((r) => {
                const t = r.travel_details || {};
                return (
                  <tr key={r.id} className="border-b border-[#F2F4F3] hover:bg-[#FAFAF7]" data-testid={`travel-row-${r.id}`}>
                    <td className="px-4 py-3 font-medium text-[#2A332C]">{r.patient_info?.full_name}</td>
                    <td className="px-4 py-3 text-[#5C6660]">{countryFlag(r.patient_info?.nationality)} {r.patient_info?.nationality}</td>
                    <td className="px-4 py-3 text-[#5C6660]">{fmtDate(t.proposed_arrival_date)}</td>
                    <td className="px-4 py-3 text-[#5C6660]">{fmtDate(t.proposed_departure_date)}</td>
                    <td className="px-4 py-3 text-[#5C6660]">{t.arrival_airport || "—"}</td>
                    <td className="px-4 py-3 text-xs">
                      <span className={`px-2 py-0.5 rounded-full font-semibold ${t.airport_pickup_required ? "bg-[#E6F0EB] text-[#2A4D3E]" : "bg-[#F2F4F3] text-[#8E9992]"}`}>
                        {t.airport_pickup_required ? "Required" : "Not needed"}
                      </span>
                    </td>
                    <td className="px-4 py-3"><button onClick={() => nav(`${base}/visa/${r.id}`)} className="text-[#2A4D3E]" data-testid={`travel-open-${r.id}`}><ExternalLink size={14} /></button></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
